import React from 'react';
import { Select } from 'antd';

const SelectComponent2 = ({
    label,
    id,
    name,
    value,
    onChange,
    options = [],
    className,
    readOnly,
    required,
    placeholder,
    error,
    showSearch = false,
    style = { width: '100%' },
}) => {
    return (
        <div className={`w-full flex flex-col items-start justify-center gap-1 ${readOnly && 'opacity-50 cursor-not-allowed'}`}>
            <label htmlFor={id} className="text-sm text-gray-500 font-normal w-full">
                {label} {required && <span className="text-red-500">*</span>}
            </label>
            <Select
                bordered={false}
                showSearch={showSearch}
                id={id}
                className={`${readOnly && 'pointer-events-none'} ${className}  border rounded-md`}
                placeholder={placeholder}
                value={value}
                options={options}
                onChange={(val) => onChange(val)}
                style={style}
            />
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
};

export default SelectComponent2;